import { useState, useRef } from "react";
import { ProductScheme } from "client-v2";
import { useDispatch, useSelector } from "react-redux";
import { actionsCreators, State } from "../../redux";
import { bindActionCreators } from "redux";

import WizardContainer, {
	WizardContainerRef,
} from "../../components/container/WizardContainer";
import Success from "../../components/section/success/Success";
import SuccessRight from "../../components/section/success/SuccessCrossSell";
import PaymentMethod from "../../components/section/donation/PaymentMethod";
import { useLocation } from "react-router";

const Checkout = (props: Props) => {
	const { state } = useLocation();
	const dispatch = useDispatch();
	const { setShowError } = bindActionCreators(actionsCreators, dispatch);
	const isMobile: boolean = useSelector(
		(state: State) => state.screen.isMobile
	);
	const currentUser = useSelector((state: State) => state.user.currentUser);

	const wizard = useRef<WizardContainerRef>(null);

	const view = "donation";
	const [product, setProduct] = useState<ProductScheme>(state);

	const onBackClick = (step: number) => {
		if (step === 5) {
			wizard.current?.goBack(1, step);
		}
	};

	return (
		<WizardContainer
			ref={wizard}
			onBackClick={onBackClick}
			views={[
				//Select payment method
				{
					centralView:
						product && currentUser ? (
							<PaymentMethod
								product={product}
								user={currentUser}
								view={view}
								onFinish={(result) => {
									if (result.error) {
										setShowError({
											show: true,
											message: result.error,
										});
									} else if (result.data) {
										wizard.current?.goNext();
									}
								}}
								onProductChange={(result) => {
									if (result.error) {
										setShowError({
											show: true,
											message: result.error,
										});
									} else if (result.data) {
										setProduct(result.data);
									}
								}}
							/>
						) : null,
				},
				//Success view
				{
					centralView:
						currentUser && product ? (
							<Success
								user={currentUser}
								didSubscribe={product.charge}
								title={`¡Gracias por tu donación, ${currentUser.name}!`}
								subtitle="Con tu ayuda y la de otras muchas personas podremos continuar con nuestra misión de acabar con la soledad no deseada de las personas mayores."
								type="donation"
								thankYouVideo={{
									urlSmall:
										"https://adoptaunabuelo.org/wp-content/uploads/2025/06/thank_u_small.mp4",
									url: "https://adoptaunabuelo.org/wp-content/uploads/2025/06/thank_u.mp4",
									label: "Luci y Alberto te dan las gracias",
								}}
							/>
						) : null,
					rightViewStyle: { position: "unset" },
					rightView: !isMobile ? <SuccessRight /> : null,
					hideBackButton: true,
				},
			]}
		/>
	);
};
export default Checkout;
export interface Props {}
